import React from 'react'
import { Area } from '../../../../../_models/Report.model'
import { Col, Container, Row } from 'react-bootstrap'
import { ReportSubAreaView } from './ReportSubAreaView'
import { useReportContext } from '../../../../../_context/ReportContext'
import { DomesticReportScoreOutput } from './DomesticReportSpecificElements/DomesticReportScoreOutput'
import { DomesticAreaAndItemView } from './DomesticReportSpecificElements/DomesticAreaAndItemView'
import { ClientType } from '../../../../../_models/Client.model'


interface ReportAreaViewProps {
    Areas: Area[]
}

export const ReportAreaView: React.FC<ReportAreaViewProps> = ({ Areas }) => {
    const { currentViewingReport } = useReportContext()
    const area_based_scoring_types = process.env.REACT_APP_AREA_BASED_SCORING_TYPES?.split(",");

    // Check if this client type should use area-based scoring display (like Domestic)
    const shouldUseAreaBasedDisplay =
        area_based_scoring_types?.includes(currentViewingReport.Client.Type.toString()) ||
        currentViewingReport.Client.Type === ClientType.NDIS ||
        currentViewingReport.Client.Type === ClientType.Domestic;

    return (
        <>
            {Areas.map(area => (
                <Row className='areaContainer'>
                    <Col sm={shouldUseAreaBasedDisplay ? 8 : 12}>
                        <h3 className='reportAreaName'>
                            {area.Name}
                        </h3>
                        {shouldUseAreaBasedDisplay && <DomesticAreaAndItemView subAreas={area.SubAreas} />}
                    </Col>
                    <Col sm={shouldUseAreaBasedDisplay ? 4 : 12}>
                        <Container>
                            {shouldUseAreaBasedDisplay && <DomesticReportScoreOutput SubAreas={area.SubAreas} />}
                            {!shouldUseAreaBasedDisplay && <ReportSubAreaView SubAreas={area.SubAreas} />}
                        </Container>
                    </Col>
                    {shouldUseAreaBasedDisplay && <hr className='mt-4' />}
                </Row>
            ))}
        </>
    )
}
